import React from 'react';

import Lottie from 'react-lottie-wrapper';
import PropTypes from 'prop-types';

import animationData from 'assets/lottie/screen-loader.json';
import animationDataWhite from 'assets/lottie/screen-loader-white.json';

const defaultOptions = {
  loop: true,
  autoplay: true,
  rendererSettings: {
    progressiveLoad: true,
    preserveAspectRatio: 'xMidYMid meet',
  },
};

function ScreenLoaderAnimation({ width, isWhite }) {
  return (
    <Lottie
      options={{
        ...defaultOptions,
        animationData: !isWhite ? animationData : animationDataWhite,
      }}
      style={{
        width,
      }}
    />
  );
}

ScreenLoaderAnimation.defaultProps = {
  width: '300px',
  isWhite: false,
};

ScreenLoaderAnimation.propTypes = {
  width: PropTypes.string,
  isWhite: PropTypes.bool,
};

export default ScreenLoaderAnimation;
